import { assertResponse } from './Utils';

// Toggles a favorite move for the current user on a given game. `favorite` is the
// desired next state (true = mark favorite, false = unmark). Auth is required.
async function toggleFavoriteMove(gameId: number, pgn: string, favorite: boolean): Promise<void> {
  const url =
    '/api/Games/favoriteMove?gameId=' +
    gameId +
    '&pgn=' +
    encodeURIComponent(pgn) +
    '&favorite=' +
    favorite;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
  await assertResponse(response);
}

export default {
  toggleFavoriteMove,
};
